/**
 * LoadingProgress Component
 *
 * Displays a horizontal progress bar showing texture loading percentage.
 * Shows "Ready!" when loading is complete.
 *
 * Used in:
 * - VS Screen overlay during texture preloading
 */

import styles from './LoadingProgress.module.css';

export interface LoadingProgressProps {
  /** Loading progress from 0 to 1 */
  progress: number;
}

/**
 * LoadingProgress Component
 *
 * Renders a progress bar with smooth width transitions
 * and percentage display. Shows "Ready!" when complete.
 */
export function LoadingProgress({ progress }: LoadingProgressProps) {
  // Clamp progress to valid range
  const clampedProgress = Math.max(0, Math.min(1, progress));
  const isComplete = clampedProgress >= 1;
  const percentage = Math.round(clampedProgress * 100);

  return (
    <div className={styles.container}>
      {/* Progress bar container */}
      <div className={styles.barContainer}>
        {/* Progress fill */}
        <div
          className={styles.barFill}
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Percentage or Ready text */}
      <span className={styles.text}>
        {isComplete ? 'Ready!' : `${percentage}%`}
      </span>
    </div>
  );
}

export default LoadingProgress;
